// extracted by mini-css-extract-plugin
export var attribution = "_cs-4";
export var authorName = "_cs-5";
export var quote = "_cs-3";
export var testimonial = "_cs-2";
export var trustedBy = "_cs-0";
export var trustedByLabel = "_cs-1";